import { useEffect } from 'react';
import ImpressumContent from '../components/legal/ImpressumContent';

const Legal = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Impressum</h1>
        <ImpressumContent />
      </div>
    </div>
  );
};

export default Legal;
